import { render, staticRenderFns } from "./QuickberrySmsIntegration.vue?vue&type=template&id=59324dd2&scoped=true"
import script from "./QuickberrySmsIntegration.vue?vue&type=script&lang=js"
export * from "./QuickberrySmsIntegration.vue?vue&type=script&lang=js"
import style0 from "./QuickberrySmsIntegration.vue?vue&type=style&index=0&id=59324dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59324dd2",
  null
  
)

export default component.exports